import { useEffect } from "react";
import { useDispatch } from "react-redux";
import useTypedSelector from "@hooks/useTypedSelector";
import { hideAppLoadingSkeleton } from "@stores/ui/slices";

/**
 * Dispatches hideAppLoadingSkeleton when ready. Use in layout components so skeleton hides when page content is ready.
 * @param ready - Only hide when true (e.g. skip during auth check)
 */
export const useAppReady = (ready = true) => {
  const dispatch = useDispatch();
  const isVisible = useTypedSelector((state) => state.ui.appLoadingSkeletonVisible);

  useEffect(() => {
    if (ready && isVisible) {
      dispatch(hideAppLoadingSkeleton());
    }
  }, [dispatch, isVisible, ready]);
};
